module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAA8CAMAAACQLyDIAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABUUExURfOgFvinP/akMPOxKPOiFvemOvOoGvW+PvSgG/WhJfWmP/OlF/W6N/SqHvS3MvS0LfSgIPSvJPaiK/ioQvekNfOsIfK8O/C5NvW8OvGkOey1MO6iMTuMMU8AAAA7SURBVAjXVcHHEQAhEASxOe+9BfLPk64tPkgKchp5sWBjb5Y8Odidvc3VdmLLhY8OVty4cuavLn31yUeOBAJ1z8kQnQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/year-select-bg.png
// module id = 552
// module chunks = 0